import { ReactElement, useState } from 'react';
import styles from './commandBar.module.css';
import { CommandGroup } from './commandGroup';
import { Button } from 'primereact/button';

export interface CommandBarProps {
  groups: PoemCommandGroup[];
}

export interface PoemCommandGroup {
  label: string;
  commands: (PoemCommand | ReactElement)[];
  displayStyle?: 'inline' | 'grid';
}

export interface PoemCommand {
  onClick: () => void;
  label: string;
  icon?: string;
  disabled?: boolean;
  tooltip?: string;
}

export const CommandBar = ({ groups }: CommandBarProps) => {
  const [isCollapsed, setIsCollapsed] = useState(true);

  return (
    <div className={styles.commandBar} data-collapsed={isCollapsed}>
      <Button
        type="button"
        text
        size="small"
        onClick={() => setIsCollapsed(!isCollapsed)}
        aria-label={isCollapsed ? 'Expand command bar' : 'Collapse command bar'}
        aria-expanded={!isCollapsed}
        className={styles.toggleButton}
        icon={isCollapsed ? 'pi pi-angle-down' : 'pi pi-angle-up'}
      />
      {groups.map((group, index) => (
        <CommandGroup key={index} group={group} isCollapsed={isCollapsed} />
      ))}
    </div>
  );
};
